export default __webpack_public_path__ + "static/media/cog-browser.28d1b1bb.svg";